module.exports = __webpack_public_path__ + "img/logos-1.203a9f7.png";